import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable, pipe } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { WEBSOCKET_EVENT } from '../shared/enums/WebsocketEvent.enum';
import { SocketIoService } from './io.service';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  public url = `${environment.apiUrl}/private/notifications`;
  onNotificationsChange = new BehaviorSubject<any>({ count: 0, rows: [] });
  constructor(
    private _http: HttpClient,
    private _websocket: SocketIoService,
  ) {
    this.listenForFileNotifications();
  }

  // getAllNotifications() {
  //   this.getAll().subscribe((res) => {
  //     this.onNotificationsChange.next(res);
  //   });
  // }

  private listenForFileNotifications() {
    this._websocket.listen(WEBSOCKET_EVENT.FILE_NOTIFICATION).subscribe((notification) => {
      console.log('Nueva notificación de archivo:', notification);
      this.getAllPanel(); // Actualiza las notificaciones en el frontend
    });
  }

  getAll = (): Observable<any> =>
    this._http.get(`${this.url}/list`).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error al obtener notificaciones', error);
        throw error;
      })
    );

  getAllPanel() {
    this._http
      .get(`${this.url}/list-panel`)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener notificaciones del panel', error);
          throw error;
        })
      )
      .subscribe((res) => {
        this.onNotificationsChange.next(res);
      });
  }

  getLoadedFile(companyId: number) {
    return this._http
      .get(`${this.url}/alert-loaded-file/${companyId}`).pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al obtener notificaciones', error);
          throw error;
        })
      );
  }

  readNotification = (notificationId: number) => {
    this._http
      .put(`${this.url}/read/${notificationId}`, {})
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error al leer notificación', error);
          throw error;
        })
      )
      .subscribe(() => {
        this.getAllPanel();
      });
  };

  checkNotificationsByTask = (taskId: number): Observable<any> =>
    this._http.put(`${this.url}/check-by-task/${taskId}`, {}).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Error al leer notificación', error);
        throw error;
      })
    );
}
